// Vendor
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

// Provider
import { FolderPageProvider as EntriesDataProvider } from 'src/components/folders/FolderPageContext';

// Components
import { Loader } from 'src/components/atoms/Loader';
import ModernizedFraudAnalystReview from 'src/components/folders/ModernizedFraudAnalystReview/ModernizedFraudAnalystReview';

// Redux
import { getPendingReviewEntryThunk, selectors as myWorkSelectors } from 'src/features/myWork';

// Hooks
import { useEntriesByFolderId } from 'src/features/entries/hooks';
import { useFolderById } from 'src/features/folders/hooks';

const ReviewPageContent = () => {
  const { folderId } = useParams();
  const { isLoading: isLoadingEntries, entries } = useEntriesByFolderId(folderId as string);

  if (isLoadingEntries) {
    return <Loader />;
  }

  return <ModernizedFraudAnalystReview entries={entries} />;
};

// Nesting components to prevent data fetching conflicts between folder and entries. This because
// of the use of a provider component and to maintain standard with the FolderReviewPage
const ReviewPage = () => {
  const dispatch = useDispatch();
  const { folderId } = useParams();
  const { isLoading: isLoadingFolder } = useFolderById(folderId as string);
  const assignedEntry = useSelector(myWorkSelectors.assignedEntry);

  const isLoadingPendingSubmission = useSelector(myWorkSelectors.isLoadingPendingSubmission);

  useEffect(() => {
    dispatch(getPendingReviewEntryThunk());
  }, [dispatch]);

  if (isLoadingFolder || isLoadingPendingSubmission) {
    return <Loader />;
  }

  return (
    <EntriesDataProvider assignedEntry={assignedEntry}>
      <ReviewPageContent />
    </EntriesDataProvider>
  );
};

export default ReviewPage;
